// Browser SHA-256 (hex), via the Web Crypto API available in every modern
// browser and in Vitest's jsdom/node environment. Used to fingerprint text
// the owner accepts in-app (host terms, a negotiated commission rate) —
// mirrors `frontend/src/lib/sha256.ts`'s pure-JS implementation (that one
// avoids a native module for Expo OTA reasons; the portal has no such
// constraint and SubtleCrypto is simpler and audited).
export async function sha256Hex(input: string): Promise<string> {
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
